import { validateEditorEn } from '@Utils/validation';
import { z } from 'zod';

enum RELATED_TARGET_MESSAGE {
  DETAIL_EN = 'กรุณาระบุข้อมูลเป็นภาษาอังกฤษ',
  OTHER = 'กรุณาระบุข้อมูล',
}

export const RelatedGoalsSchema = z.object({
  isChecked: z.boolean().optional(),
  infoCategoryMasterDataId: z.number().optional(),
  nameTh: z
    .string({ message: RELATED_TARGET_MESSAGE.OTHER })
    .min(1, { message: RELATED_TARGET_MESSAGE.OTHER })
    .optional(),
  nameEn: z
    .string({ message: RELATED_TARGET_MESSAGE.OTHER })
    .min(1, { message: RELATED_TARGET_MESSAGE.OTHER })
    .regex(validateEditorEn, { message: RELATED_TARGET_MESSAGE.DETAIL_EN })
    .optional(),
});

export const RelatedTargetModalValidationSchema = z.object({
  relateGoals: z.array(RelatedGoalsSchema).optional(),
});
